export default __webpack_public_path__ + "static/avatar-max-3b80cc171eab806311489458c29d0550.png";